export const domain = function (item = null) {
    return {
        id: item == null ? null : item.id,
        name: item == null ? null : item.name,
        url: item == null ? null : item.url,
        isActive: item == null || item.isActive == undefined ? false : item.isActive,
        enabled: item == null || item.enabled == undefined ? false : item.enabled,
        deleted: item == null || item.enabled == undefined ? false : item.deleted,
        urlId: item == null || item['@id'] == undefined ? '' : item['@id']
    };
};
